<script setup lang="ts">
import {computed, watch} from "vue";
import {useTheme} from "vuetify";
import {useMessagesStore} from "./stores/messages.ts";
import {useRoute} from "vue-router";
import {THEME_NAMES} from "./vueify";

const theme = useTheme();
const route = useRoute();

const messages = useMessagesStore()

const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

const isAdminRoute = computed(() => route.path.startsWith("/admin"));

function getScopedThemeName({
  dark,
  admin,
}: {
  dark: boolean;
  admin: boolean;
}) {
  if (admin) {
    return dark ? THEME_NAMES.ADMIN_DARK : THEME_NAMES.ADMIN_LIGHT;
  }

  return dark ? THEME_NAMES.DARK : THEME_NAMES.LIGHT;
}

function updateTheme(e: MediaQueryListEvent | MediaQueryList) {
  theme.global.name.value = getScopedThemeName({
    dark: e.matches,
    admin: isAdminRoute.value,
  });
}

// Initial theme sync
updateTheme(mediaQuery)

// Listen for future changes
mediaQuery.addEventListener('change', updateTheme)

watch(
    () => route.path,
    () => {
      theme.global.name.value = getScopedThemeName({
        dark: theme.global.current.value.dark,
        admin: isAdminRoute.value,
      });
    }
);
</script>

<template>
  <RouterView />
  <v-snackbar-queue v-model="messages.queue" />
  <!-- <v-fab icon="$vuetify"></v-fab> -->
</template>

<style scoped></style>
